"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  send: function send(data) {
    return global.request.post('subscriptions/send', data);
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJzZW5kIiwiZGF0YSIsImdsb2JhbCIsInJlcXVlc3QiLCJwb3N0Il0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vbGlicmFyeS9zcmMvY2xpZW50L21vZHVsZXMvU3Vic2NyaXB0aW9uL1N1YnNjcmlwdGlvbkFjdGlvbnMuanMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQge1xyXG4gICAgc2VuZDogKGRhdGEpID0+IGdsb2JhbC5yZXF1ZXN0LnBvc3QoJ3N1YnNjcmlwdGlvbnMvc2VuZCcsIGRhdGEpLFxyXG59XHJcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7O29DQUFlO0VBQ1hBLElBQUksRUFBRSxTQUFOQSxJQUFJQSxDQUFHQyxJQUFJO0lBQUEsT0FBS0MsTUFBTSxDQUFDQyxPQUFPLENBQUNDLElBQUksQ0FBQyxvQkFBb0IsRUFBRUgsSUFBSSxDQUFDO0VBQUE7QUFDbkUsQ0FBQyJ9